import i18next from "i18next"
import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

export const Materials: React.FC = () => {
  const { t } = useTranslation()
  const currentLang = i18next.language

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <div className="container grid grid--col-12">
        <div className={styles.ColLeft}>
          <Heading className={styles.Title} like="h2">
            <Raw html={t("press.Materials.Title")} />
          </Heading>

          <div className={styles.Files}>
            <div className={styles.File}>
              <a href="/upload/press-materials-logo.zip">
                <Raw html={t("press.Materials.Files.File.Name.01")} />
              </a>

              <div className={styles.Format}>
                <Raw html={"PNG, JPG, AI"} />
              </div>
            </div>

            {currentLang === "ru" && (
              <>
                <div className={styles.File}>
                  <a href="/upload/press-materials-fonts.zip">
                    <Raw html={t("press.Materials.Files.File.Name.02")} />
                  </a>

                  <div className={styles.Format}>
                    <Raw html={"TTF"} />
                  </div>
                </div>

                <div className={styles.File}>
                  <a href="/upload/identity.zip">
                    <Raw html={t("press.Materials.Files.File.Name.03")} />
                  </a>

                  <div className={styles.Format}>
                    <Raw html={"JPG, AI"} />
                  </div>
                </div>

                <div className={styles.File}>
                  <a href="/upload/Sistema_guidelines_web.pdf">
                    <Raw html={t("press.Materials.Files.File.Name.04")} />
                  </a>

                  <div className={styles.Format}>
                    <Raw html={"PDF"} />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className={styles.ColRight}>
          <Heading like="h3">
            <Raw html={t("press.Materials.Description.01")} />
          </Heading>

          {currentLang === "ru" && (
            <div>
              <Raw html={t("press.Materials.Description.02")} />
            </div>
          )}
        </div>
      </div>
    </Theme>
  )
}
